<template>
    <v-list-item min-height="42" :disabled="disabled" :color="color" @click="handleClick">
        <div class="d-flex">
            <svg-icon :icon="icon" alt="menu-icon" />
            <v-list-item-title class="pl-4 font-weight-regular text-dark-grey text-size-lg">{{ name }}</v-list-item-title>
        </div>
    </v-list-item>
</template>

<script setup lang="ts">
import { ITravelCardMenuItem } from '../../../types';
import { TARGET_TYPES } from '@/constants';
import SvgIcon from '@/features/common/components/SvgIcon.vue';

const emit = defineEmits(['click']);

const handleClick = () => {
    emit('click');

    if (props.link) {
        window.open(props.link, props.target);
    }
};

const props = withDefaults(defineProps<ITravelCardMenuItem>(), { target: TARGET_TYPES.BLANK, disabled: false, color: '' });
</script>
